import { useTranslations } from 'next-intl'

import classnames from 'classnames'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import Image from '~/components/atoms/Image/Image'
import type { TeamMemberDetailProps } from '~/components/atoms/TeamMemberDetail/TeamMemberDetail'
import Text, { TextSizes } from '~/components/atoms/Text/Text'

import Link from '../Link/Link'
import Summary from '../Summary/Summary'

import styles from './TeamMemberProfile.module.css'

export interface TeamMemberProfileProps extends TeamMemberDetailProps {
  slug: string
  testID?: string
}

export default function TeamMemberProfile({
  name,
  image,
  jobTitle,
  description,
  articleCount,
  slug,
  testID,
}: TeamMemberProfileProps) {
  const t = useTranslations('ourPeople')
  // const hasArticles = articleCount && articleCount > 0
  const hasArticles = false

  return (
    <div className={classnames(styles.base)} data-testid={testID}>
      <Link href={`/${slug}`}>
        <div className={styles.imageContainer}>
          <Image
            asset={image.asset}
            objectFit="initial"
            sizes="(max-width: 799px) 100vw, 50vw"
            alt={image.alt}
            className={classnames(styles.image)}
          />
        </div>

        <Text
          Tag="h2"
          size={TextSizes.secondaryTitleLrg}
          className={styles.name}
        >
          {name}
        </Text>
        <Text
          Tag="h3"
          size={TextSizes.primaryTitleSml}
          className={styles.jobTitle}
        >
          {jobTitle}
        </Text>

        {description && (
          <Text size={TextSizes.bodyMed} className={styles.description}>
            <Summary limit={100} modules={description} />
          </Text>
        )}
      </Link>

      <Button
        variant={ButtonVariants.textLinkSmallUnderline}
        link={`/${slug}`}
        className={styles.viewProfileButton}
      >
        {hasArticles
          ? t('viewAllArticles', { count: articleCount || 0 })
          : t('viewProfile')}
      </Button>
    </div>
  )
}
